import script from "./BaseCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&setup=true&lang=js"

import "./BaseCarousel.vue?vue&type=style&index=0&id=01ea067c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ea067c"]])

export default __exports__